// removed by extract-text-webpack-plugin
module.exports = {"Gallery":"_2WzKb","GalleryItemOne":"_KnWJQ","GalleryItemTwo":"_3YnpM","GalleryItemThree":"_3yjsj","GalleryItemFour":"_921KQ","GalleryItemFive":"_1wrpK","GalleryImage":"_1WlyD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HotelDetail/HotelPhotos/HotelPhotos.scss
// module id = 933
// module chunks = 0